import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import Hero from '@/components/home/Hero';
import Services from '@/components/home/Services';
import Stats from '@/components/home/Stats';
import CTABanner from '@/components/home/CTABanner';
import JobOffersSlider from '@/components/home/JobOffersSlider';
import SubcontractSlider from '@/components/home/SubcontractSlider';

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <JobOffersSlider />
        <SubcontractSlider />
        <Stats />
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
}
